import React from "react";
import {ReactComponent as AddDocumentIcon} from "@assets/icons/add-document.svg";
import {ReactComponent as CloseIcon} from "@assets/icons/cross.svg";
import {classNames} from "@utils/class-names";
import FileHelper from "@utils/file-helper";
import {SelectedFileMeta} from "../../models/types/convert-document-ai-modal.types";

interface SelectedFileItemProps {
    file: SelectedFileMeta;
    disabled: boolean;
    onRemove: () => void;
}

const SelectedFileItem: React.FC<SelectedFileItemProps> = (props: SelectedFileItemProps) => {
    const {file, disabled, onRemove} = props;

    return (
        <div className="flex items-center gap-3 rounded-lg border border-outline bg-white pl-[6px] pr-1 py-1">
            <AddDocumentIcon className="w-[12px] h-4 text-on-surface/70 shrink-0"/>
            <div className="flex-1 overflow-hidden">
                <p className="text-base font-semibold truncate">{file.name}</p>
                <p className="text-xs text-on-surface/60">{FileHelper.getReadableFileSize(file.size)}</p>
            </div>
            <button
                type="button"
                onClick={onRemove}
                aria-label={`Usuń plik ${file.name}`}
                disabled={disabled}
                className={classNames(
                    "w-8 h-8 border-0 rounded-full flex items-center justify-center transition-colors shrink-0",
                    disabled ? "cursor-not-allowed !opacity-40" : "hover:bg-on-surface/5"
                )}
            >
                <CloseIcon className="w-3 h-3"/>
            </button>
        </div>
    )
};

export default SelectedFileItem;
